package presentation.screens.business.inventory.product

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.button.DefaultButton
import component.empty.EmptyData
import component.input.SearchBar
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.product.viewModel.ProductViewModel
import locale.localization
import presentation.screens.business.inventory.component.ProductCard
import presentation.screens.business.inventory.product.create.CreateProductScreen
import theme.ThemeColor

class BusinessInventoryProductList : Screen {
    @Composable
    override fun Content() {
        val viewModel = ProductViewModel()
        val navigator = LocalNavigator.current
        val allProducts = viewModel.allProduct.collectAsState()
        val searchQuery = viewModel.searchQuery.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.fetchAllProduct()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = localization().productMenu.productsTitle, onBackPress = {
                navigator?.pop()
            }, onClickAdd = {
                navigator?.push(CreateProductScreen())
            })
            AppLoader(viewModel)
            SearchBar(viewModel, searchQuery.value,localization().productMenu.productsSearchPlaceholder)
            LazyColumn(modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)) {
                item {
                    if (allProducts.value.isEmpty()) {
                        EmptyData(viewModel = viewModel)
                        DefaultButton(
                            "Create New Product",
                            onClick = { navigator?.push(CreateProductScreen()) })
                    } else {
                        Box(
                            modifier = Modifier
                                .height(50.dp)
                                .padding(start = 8.dp, end = 8.dp)
                                .background(
                                    ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = "${localization().productMenu.productsTotal} ${allProducts.value.count()} ${localization().productMenu.productsProduct}",
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier
                                    .wrapContentHeight().fillMaxWidth(),
                                textAlign = TextAlign.Center,
                                color = ThemeColor.shared().PrimaryColor
                            )
                        }
                    }
                }
                items(count = allProducts.value.count()) {
                    ProductCard(allProducts.value[it]) {

                    }
                }
            }
        }
    }
}